(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7334],{

/***/ 88198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconCheck; }
/* harmony export */ });
/* harmony import */ var _createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30853);
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconCheck = (0,_createReactComponent_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", "IconCheck", [
  ["path", { d: "M5 12l5 5l10 -10", key: "svg-0" }]
]);


//# sourceMappingURL=IconCheck.js.map


/***/ }),

/***/ 22253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ FinancesEducationLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.js + 1 modules
var createReactComponent = __webpack_require__(30853);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconMenu2.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconMenu2 = (0,createReactComponent/* default */.Z)("menu-2", "IconMenu2", [
  ["path", { d: "M4 6l16 0", key: "svg-0" }],
  ["path", { d: "M4 12l16 0", key: "svg-1" }],
  ["path", { d: "M4 18l16 0", key: "svg-2" }]
]);


//# sourceMappingURL=IconMenu2.js.map

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/pages/[company]/_layout.tsx + 1 modules
var _layout = __webpack_require__(59906);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
// EXTERNAL MODULE: ./src/pages/[company]/finances/education/_layout.module.scss
var _layout_module = __webpack_require__(70535);
var _layout_module_default = /*#__PURE__*/__webpack_require__.n(_layout_module);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/education/_layout.tsx










const FinancesEducationLayout = (props)=>{
    const companySlug = (0,router.useRouter)().query.company;
    const educationRouter = _router/* default.company */.Z.company(companySlug).finances.education;
    const financeSettings = init/* api.financeSettings.useFinanceSettingsGet */.h.financeSettings.useFinanceSettingsGet(companySlug);
    const onSkip = async ()=>{
        await init/* api.financeSettings.financeSettingsUpdateEducation */.h.financeSettings.financeSettingsUpdateEducation(companySlug, {
            education: false
        });
        await financeSettings.mutate();
        await router_default().push(_router/* default.company */.Z.company(companySlug).finances.href);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_layout/* CompanyLayout */.q, {
        title: "Знакомство с модулем \xabФинансы\xbb",
        actions: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
            type: "secondary",
            onClick: onSkip,
            children: "Пропустить обучение"
        }),
        className: classnames_default()((_layout_module_default())._layout, props.className),
        style: props.style,
        htmlId: props.htmlId,
        children: [
            props.step && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (_layout_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(button_button/* Button */.z, {
                        type: "secondary",
                        onClick: ()=>router_default().push(educationRouter.tableOfContent.href),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMenu2, {
                                size: 20,
                                stroke: 1.5
                            }),
                            " Оглавление"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            props.step,
                            " / 15"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: props.title
                    })
                ]
            }),
            props.children
        ]
    });
};
FinancesEducationLayout.defaultProps = {};


/***/ }),

/***/ 27334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.js + 1 modules
var createReactComponent = __webpack_require__(30853);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconFileCheck.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconFileCheck = (0,createReactComponent/* default */.Z)("file-check", "IconFileCheck", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M9 15l2 2l4 -4", key: "svg-2" }]
]);


//# sourceMappingURL=IconFileCheck.js.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconPlaylistX.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconPlaylistX = (0,createReactComponent/* default */.Z)("playlist-x", "IconPlaylistX", [
  ["path", { d: "M19 8h-14", key: "svg-0" }],
  ["path", { d: "M5 12h7", key: "svg-1" }],
  ["path", { d: "M12 16h-7", key: "svg-2" }],
  ["path", { d: "M16 14l4 4", key: "svg-3" }],
  ["path", { d: "M20 14l-4 4", key: "svg-4" }]
]);


//# sourceMappingURL=IconPlaylistX.js.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconTrophy.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconTrophy = (0,createReactComponent/* default */.Z)("trophy", "IconTrophy", [
  ["path", { d: "M8 21l8 0", key: "svg-0" }],
  ["path", { d: "M12 17l0 4", key: "svg-1" }],
  ["path", { d: "M7 4l10 0", key: "svg-2" }],
  ["path", { d: "M17 4v8a5 5 0 0 1 -10 0v-8", key: "svg-3" }],
  ["path", { d: "M5 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-4" }],
  ["path", { d: "M19 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-5" }]
]);


//# sourceMappingURL=IconTrophy.js.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconChartBar.js
/**
 * @tabler/icons-react v2.22.0 - MIT
 */



var IconChartBar = (0,createReactComponent/* default */.Z)("chart-bar", "IconChartBar", [
  [
    "path",
    {
      d: "M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-1"
    }
  ],
  [
    "path",
    {
      d: "M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-2"
    }
  ],
  ["path", { d: "M4 20l14 0", key: "svg-3" }]
]);


//# sourceMappingURL=IconChartBar.js.map

// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconCheck.js
var IconCheck = __webpack_require__(88198);
// EXTERNAL MODULE: ./src/modules/layout/ui/container/container.tsx
var container = __webpack_require__(57711);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/pages/_router.tsx
var _router = __webpack_require__(8254);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/api/init.tsx + 231 modules
var init = __webpack_require__(32636);
// EXTERNAL MODULE: ./src/shared/ui/button/button.tsx
var button_button = __webpack_require__(76780);
// EXTERNAL MODULE: ./src/shared/ui/youtube-embed/youtube-embed.tsx
var youtube_embed = __webpack_require__(21627);
// EXTERNAL MODULE: ./src/pages/[company]/finances/education/_layout.tsx + 1 modules
var _layout = __webpack_require__(22253);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/education/images/fp.png
/* harmony default export */ var fp = ({"src":"/_next/static/media/fp.73ab3346.png","height":3274,"width":3200,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEX6+vr39/f09PT+/v7v7+/c3Ny0JN5bAAAACXBIWXMAABYlAAAWJQFJUiTwAAAALElEQVR4nGWLuQ0AMBCDML7sv3KeNg1CQiBtm0GCnYXRIRCSJ+aTl+TOeLABD7cAa1TxAKYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/pages/[company]/finances/education/index.page.module.scss
var index_page_module = __webpack_require__(64807);
var index_page_module_default = /*#__PURE__*/__webpack_require__.n(index_page_module);
;// CONCATENATED MODULE: ./src/pages/[company]/finances/education/index.page.tsx












const FinancesEducationPage = ()=>{
    const companySlug = (0,router.useRouter)().query.company;
    const educationRouter = _router/* default.company */.Z.company(companySlug).finances.education;
    const settings = init/* api.financeSettings.useFinanceSettingsGet */.h.financeSettings.useFinanceSettingsGet(companySlug);
    const onNext = async ()=>{
        await init/* api.financeSettings.financeSettingsUpdateEducationStep */.h.financeSettings.financeSettingsUpdateEducationStep(companySlug, {
            educationStep: 1
        });
        await settings.mutate();
        return router_default().push(educationRouter.step("01").href);
    };
    const onSkip = async ()=>{
        await init/* api.financeSettings.financeSettingsUpdateEducation */.h.financeSettings.financeSettingsUpdateEducation(companySlug, {
            education: false
        });
        await settings.mutate();
        return router_default().push(_router/* default.company */.Z.company(companySlug).finances.href);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_layout/* FinancesEducationLayout */.A, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (index_page_module_default()).index_page,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* Container */.W, {
                className: (index_page_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_page_module_default()).head,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_page_module_default()).main,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (index_page_module_default()).title,
                                        children: "Наведите порядок в финансах и сделайте бизнес более прибыльным"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).subtitle,
                                        children: "Создайте финансовую модель. Спланируйте бюджет на месяц. Внедрите систему заявок на расходы."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                        className: (index_page_module_default()).button,
                                        size: "large",
                                        onClick: onNext,
                                        children: "Начать знакомство с модулем"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_page_module_default()).video,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube_embed/* YoutubeEmbed */.H, {
                                    embedId: "NYTqvJxljo4"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_page_module_default()).card_list,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_page_module_default()).card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFileCheck, {
                                            size: 40,
                                            stroke: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).title,
                                        children: "Порядок и\xa0контроль финансов"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).description,
                                        children: "Собственник управляет цифрами в\xa0бизнесе. Перед глазами\xa0— простая и\xa0понятная отчетность движения денег."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_page_module_default()).card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconPlaylistX, {
                                            size: 40,
                                            stroke: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).title,
                                        children: "Оптимизация расходов и\xa0долгов"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).description,
                                        children: "Система фондов убирает лишние расходы и\xa0позволяет накопить денежные резервы."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_page_module_default()).card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTrophy, {
                                            size: 40,
                                            stroke: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).title,
                                        children: "Сотрудники бьются за\xa0доход"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).description,
                                        children: "Система ЗП\xa0от\xa0результата поднимает ответственность топов за\xa0доходы и\xa0расходы компании."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_page_module_default()).card,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconChartBar, {
                                            size: 40,
                                            stroke: 2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).title,
                                        children: "Больше денег собственнику"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_page_module_default()).description,
                                        children: "Владелец получает дивиденды. Его процент закладывается в\xa0финансовую модель и\xa0выплачивается еженедельно."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_page_module_default()).large_card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (index_page_module_default()).main,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                        className: (index_page_module_default()).title,
                                        children: [
                                            "Научитесь эффективной системе управления финансами при помощи интерактивного урока.",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_page_module_default()).list,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_page_module_default()).list_item,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                                                            size: 20,
                                                            stroke: 1.5
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).text,
                                                        children: "Создадим финансовую модель вашего бизнеса"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_page_module_default()).list_item,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                                                            size: 20,
                                                            stroke: 1.5
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).text,
                                                        children: "Организуем контроль расходов при помощи системы фондов. Научимся заранее планировать траты и накапливать на них средства"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_page_module_default()).list_item,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                                                            size: 20,
                                                            stroke: 1.5
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).text,
                                                        children: "Поймем, как при помощи плана бюджета на месяц сделать так, чтобы компания работала в плюс"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_page_module_default()).list_item,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                                                            size: 20,
                                                            stroke: 1.5
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).text,
                                                        children: "Создадим бюджет вашей компании на месяц"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (index_page_module_default()).list_item,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).icon,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCheck/* default */.Z, {
                                                            size: 20,
                                                            stroke: 1.5
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (index_page_module_default()).text,
                                                        children: "Научимся добиваться выполнения плана"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (index_page_module_default()).actions,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                                size: "large",
                                                type: "primary",
                                                onClick: onNext,
                                                children: "Начать знакомство с модулем"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* Button */.z, {
                                                size: "large",
                                                type: "secondary",
                                                onClick: onSkip,
                                                children: "Пропустить обучение и перейти в Финансы"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (index_page_module_default()).image,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: fp,
                                    alt: ""
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var index_page = (FinancesEducationPage);


/***/ }),

/***/ 21627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ YoutubeEmbed; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _youtube_embed_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48998);
/* harmony import */ var _youtube_embed_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_youtube_embed_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const YoutubeEmbed = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_youtube_embed_module_scss__WEBPACK_IMPORTED_MODULE_3___default().youtube_embed), props.className),
        style: props.style,
        id: props.htmlId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            width: "853",
            height: "480",
            src: "https://www.youtube.com/embed/".concat(props.embedId),
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            title: "Embedded youtube"
        })
    });
};
YoutubeEmbed.defaultProps = {};


/***/ }),

/***/ 70535:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"_layout_header__m0qQW"};

/***/ }),

/***/ 64807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"index_page":"index_page_index_page__Y8s_W","container":"index_page_container__oQUtZ","head":"index_page_head__fMae8","main":"index_page_main__B_yi2","title":"index_page_title__ONAOr","subtitle":"index_page_subtitle__YTukS","button":"index_page_button__fTr_E","video":"index_page_video__weoVq","card_list":"index_page_card_list__C1c5V","card":"index_page_card__lcjdE","description":"index_page_description___sWFM","large_card":"index_page_large_card__Ia4kb","list":"index_page_list__1IpeH","list_item":"index_page_list_item__M_OKQ","actions":"index_page_actions__ELwn7","image":"index_page_image__j82zJ"};

/***/ }),

/***/ 48998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"youtube_embed":"youtube-embed_youtube_embed__q0tM9"};

/***/ })

}]);